// extracted by mini-css-extract-plugin
module.exports = {"content":"newsCardComponent_content__2FW7-","container":"newsCardComponent_container__3Co0x","image":"newsCardComponent_image__2ORRe","date":"newsCardComponent_date__3dWei","price":"newsCardComponent_price__1DId6","text":"newsCardComponent_text__3jvA4","readMore":"newsCardComponent_readMore__3nq9C","textGradient":"newsCardComponent_textGradient__s2Fe0"};
    if(module.hot) {
      // 1790670292332
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  